/**
 * @file Drop task
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { DropBase } from './drop-base';
var TaskDrop = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDrop, _super);
    /**
     * Creates an instance of TaskDrop.
     */
    function TaskDrop(domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        return _super.call(this, 'task-drop', 'APP.EXECUTORS.TASK_DROP_NAME', ['Task'], 'Task', domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
    }
    /**
     * The business logic for this executor and is executed after the validation step and before the finish step.
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    TaskDrop.prototype.process = function (data) {
        var _this = this;
        var sliced = this.explodeExecutorData(data);
        // Execute the async functions one by one (serial)
        return this.runPromisesSerial(sliced, function (slice) {
            return _this.dropTask(slice.target, slice.resource, slice.item);
        });
    };
    /**
     * Drop a task
     * @private
     * @param {ExecutorTimeslot} target
     * @param {Resource} resource
     * @param {Entity} item
     * @returns {Promise<any>}
     */
    TaskDrop.prototype.dropTask = function (target, resource, item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            resource.fillwith(item['Oid'], target.start.toDate(), target.finish.toDate(), 'FORCEDROP', true);
            _this.subscriptionPool.add(_this.trySaveChanges(reject).subscribe(function (result) {
                var resourceOid = resource.Oid;
                var methodResult = result.entities.find(function (entity) { return entity['Origin'] === resourceOid && entity['Name'] === 'FillWith'; });
                if (methodResult) {
                    var values = methodResult['Value'];
                    resolve(values);
                }
                else {
                    resolve();
                }
            }));
        });
    };
    /**
     * The logic for the showing the valid drop targets
     * @param {ExecutorData} data
     */
    TaskDrop.prototype.showDropTargets = function (data) {
        var _this = this;
        // Use the DropTargetService to make the drop targets visible
        this.dropTargetsService.doComplyResourcesDropTargets(data, function () {
            return _this.dropTargetsService.doFirstOpenTimeslotDropTargets(data);
        });
    };
    return TaskDrop;
}(DropBase));
export { TaskDrop };
